import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import Cart from "../components/Cart/Cart";
import "./EcommerceDefaultWrapper.scss"
import SearchComponent from "../components/SearchComponent/SearchComponent";
import { getLocalStorageData, LOCAL_STORAGE_ITEMS_NAMES } from "../../../../utilities/helper";
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from "react-redux";
import { getWishlist } from "../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { setWishlist } from "../../../../../../redux/companyDataSlice";
import axios from "axios";
import config from "react-global-configuration";
import jwt from "jsonwebtoken";
import Modal from "../components/Modal/Modal";
import { useHistory } from "react-router";

const EcommerceDefaultWrapper = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [isShowLoginModal, setIsShowLoginModal] = useState(false);

    const companyData = useSelector((state) => state.companyData.company)
    const dispatch = useDispatch()
    const history = useHistory()

    const getSettings = () => {
        const timestamp = Math.floor(Date.now() / 1000) + 1000;

        var payload = {
            aud: config.get("ProductjwtAud"),
            exp: timestamp,
            iss: config.get("ProductjwtIss"),
        };

        var signOptions = {
            algorithm: "RS256",
        };

        var privateKey = config.get("ProductprivateKey");
        var token = jwt.sign(payload, privateKey, signOptions);

        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ` + token,
            },
        };

        var payload2 = {
            aud: config.get("SalesjwtAud"),
            exp: timestamp,
            iss: config.get("SalesjwtIss"),
        };

        var privateKey2 = config.get("SalesprivateKey");
        var token2 = jwt.sign(payload2, privateKey2, signOptions);
        axios
            .get(
                config.get("API_salesregistry") +
                "setting/" +
                config.get("OrganisationID") +
                "/26",
                { headers: { Authorization: "Bearer " + token2 } }
            ).then((response) => {
                localStorage.setItem("ECOM_SETTINGS", JSON.stringify(response.data.Result));
            })
    }


    const handleUser = async () => {
        let userUUID = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);
        const userDetails = localStorage.getItem('fullUserDetails');

        if (!userDetails) {
            if (!userUUID) {
                userUUID = uuidv4();
                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID, userUUID);
            }
        } else {
            let user = JSON.parse(userDetails);
            userUUID = user.UserID;
            localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID, userUUID);
        }

        return userUUID;
    };

    const fetchData = async () => {
        const userId = await handleUser()
        if (companyData && userId) {
            await getWishlist(companyData?.LocationID, userId).then((res) => {
                if (res) {
                    dispatch(setWishlist(res))
                }
            }).catch((error) => {
                dispatch(setWishlist([]))

            })
        }
    }
    useEffect(() => {
        getSettings()
        fetchData()
    }, [companyData])

    return (
        <div className="EcommerceDefaultWrapper" >
            <Cart isOpen={isOpen} setIsOpen={setIsOpen} setIsShowLoginModal={setIsShowLoginModal} />
            <Navbar setIsOpen={setIsOpen} setIsSearchOpen={setIsSearchOpen} />
            {children}
            <Footer />
            <SearchComponent isOpen={isSearchOpen} setIsOpen={setIsSearchOpen} />
            {isShowLoginModal && <Modal isAlert header={"Login Required"} subText={"To continue with your checkout, please log in to your account."} buttonText="Log In Now"
                onClick={() => {
                    setIsShowLoginModal(false)
                    history.push("/account/login")

                }}

                onCancel={() => {
                    setIsShowLoginModal(false)
                }} />}
        </div>

    )

}
export default EcommerceDefaultWrapper;